export default __webpack_public_path__ + "static/media/ico_modal_close_Kbank.1aa9dcd8.svg";